export default __webpack_public_path__ + "static/media/rightIcon.6090ad6c.svg";